module.exports = __webpack_public_path__ + "img/03.0b57d4b1.jpg";